module.exports = {"heading":"Vui lòng chọn cửa hàng yêu thích của bạn hoặc nhập mới","placeholder1":"URL quán trà sữa bạn thích","button":"Gửi","interneterr":"Vui lòng kiểm tra đường truyền internet","invalidurl":"Vui lòng truyền đúng địa chỉ delivery now url","select":"Chọn...","milktea":"Tên món trà sữa tìm kiếm","rangeLowest":"Mức giá thấp nhất","rangeHighest":"Mức giá cao nhất","total":"Tổng số:","shareLink":"Lấy link chia sẽ","copyLink":"Sao chép đường dẫn"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/vi.json
// module id = 472
// module chunks = 0